export const SAMPLE_CSV_HEADERS = [
  'SerialNo',
  'SensorType',
  'Category',
  'Model',
  'Range',
  'BOL',
  'AOL',
  'col_16',
  'col_7',
  'col_15',
  'col_17',
  'col_8',
  'col_14',
  'col_18',
  'col_9',
  'col_13',
  'col_19',
  'col_10',
  'col_12',
  'col_20',
  'col_11',
  'col_21',
  'RoomT',
  'RoomF',
];

export const buildSampleCsvContent = (): string => {
  const rows = [
    SAMPLE_CSV_HEADERS.join(','),
    'S-1001,Accelerometer,Accelerometer,Model A,150kPa,100,120,0,10,20,30,40,50,60,70,80,90,100,110,120,130,24,25',
    'S-1002,Displacement,Displacement,Model B,250mm,120,150,0,15,25,35,45,55,65,75,85,95,105,115,125,135,23,24',
    'S-1003,Piezometer,Piezometer,Model C,200psi,140,180,0,18,28,38,48,58,68,78,88,98,108,118,128,138,22,23',
  ];

  return rows.join('\n');
};

const pad2 = (value: number): string => (value < 10 ? `0${value}` : `${value}`);

const formatSampleDate = (date = new Date()): string => {
  const day = pad2(date.getDate());
  const month = pad2(date.getMonth() + 1);
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

export const buildGeneratedSampleCsv = ({
  frequencyText,
  temperatureText,
  serialCount = 5,
}: {
  frequencyText: string;
  temperatureText: string;
  serialCount?: number;
}): string => {
  const serialNumbers = Array.from({ length: serialCount }, (_, index) => `S-${1001 + index}`);
  const header = [formatSampleDate(), ...serialNumbers];
  const rows: string[][] = [header];

  const parseInputRows = (text: string) => text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const separatorIndex = line.search(/[\t:]/);
      if (separatorIndex < 0) return { label: line, value: '' };
      return {
        label: line.slice(0, separatorIndex).trim(),
        value: line.slice(separatorIndex + 1).trim(),
      };
    });

  parseInputRows(frequencyText).forEach(({ label, value }) => {
    rows.push([label, ...Array.from({ length: serialCount }, () => value)]);
  });

  parseInputRows(temperatureText).forEach(({ label, value }) => {
    rows.push([label, ...Array.from({ length: serialCount }, () => value)]);
  });

  return rows
    .map((row) =>
      row
        .map((cell) => {
          const normalized = String(cell ?? '');
          return `"${normalized.replace(/"/g, '""')}"`;
        })
        .join(',')
    )
    .join('\n');
};

export const downloadCsvTemplate = (content: string, fileName = 'calibration-sample.csv') => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  window.URL.revokeObjectURL(url);
};
